<div class="card">
  <h2 class="card-title">Academic progress reports</h2>

  <div class="card-body">
    <form [formGroup]="filters" class="toolbar" (ngSubmit)="load()">
      <label>
        Cycle
        <input type="text" formControlName="cycle" placeholder="e.g. 2026" />
      </label>

      <label>
        Scholarship
        <select formControlName="scholarshipId">
          <option [ngValue]="null">All scholarships</option>
          @for (scholarship of scholarships(); track scholarship.id) {
            <option [ngValue]="scholarship.id">{{ scholarship.title }}</option>
          }
        </select>
      </label>

      <label>
        Status
        <select formControlName="status">
          <option value="">All statuses</option>
          @for (status of statuses; track status) {
            <option [value]="status">{{ status }}</option>
          }
        </select>
      </label>

      <label>
        Search
        <input type="text" formControlName="search" placeholder="Student, report or award" />
      </label>

      <div class="toolbar-actions">
        <button type="submit" class="btn btn-primary btn-sm"><i class="fas fa-search"></i> Filter</button>
      </div>
    </form>

    @if (error()) {
      <div class="alert alert-warning"><i class="fas fa-exclamation-circle"></i> {{ error() }}</div>
    }
    @if (message()) {
      <div class="alert alert-success"><i class="fas fa-check-circle"></i> {{ message() }}</div>
    }

    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>Reference</th>
            <th>Student</th>
            <th>Scholarship</th>
            <th>Cycle</th>
            <th>Period</th>
            <th>Average</th>
            <th>Submitted</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          @if (loading()) {
            <tr><td colspan="9" class="empty-cell"><i class="fas fa-spinner fa-spin"></i> Loading reports…</td></tr>
          }
          @if (!loading() && reports().length === 0) {
            <tr><td colspan="9" class="empty-cell">No progress reports match these filters.</td></tr>
          }
          @for (report of reports(); track report.id) {
            <tr>
              <td>{{ report.referenceNumber }}</td>
              <td>{{ report.studentName || '—' }}</td>
              <td>{{ report.scholarshipTitle || '—' }}</td>
              <td>{{ report.cycle }}</td>
              <td>{{ report.academicPeriod || '—' }}</td>
              <td>{{ report.averageScore !== null && report.averageScore !== undefined ? (report.averageScore | number: '1.2-2') : '—' }}</td>
              <td>{{ report.submittedDate | date: 'mediumDate' }}</td>
              <td>
                <span [class]="statusClass(report.status)">{{ report.status }}</span>
                @if (report.reviewerFeedback) { <small>{{ report.reviewerFeedback }}</small> }
              </td>
              <td>
                <button type="button" class="btn btn-secondary btn-sm" (click)="open(report)">Open</button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>


@if (selected(); as report) {
  <div class="modal-backdrop" (click)="close()">
    <div class="modal-dialog" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>Progress report {{ report.referenceNumber }}</h2>
        <button class="modal-close" (click)="close()"><i class="fas fa-times"></i></button>
      </div>

      <div class="modal-body">
        <div class="detail-grid">
          <div class="detail-item"><span class="detail-label">Status</span>
            <span class="detail-value"><span [class]="statusClass(report.status)">{{ report.status }}</span></span>
          </div>
          <div class="detail-item"><span class="detail-label">Student</span><span class="detail-value">{{ report.studentName || '—' }}</span></div>
          <div class="detail-item"><span class="detail-label">Scholarship</span><span class="detail-value">{{ report.scholarshipTitle }}</span></div>
          <div class="detail-item"><span class="detail-label">Award</span><span class="detail-value">{{ report.awardReferenceNumber }}</span></div>
          <div class="detail-item"><span class="detail-label">Cycle</span><span class="detail-value">{{ report.cycle }}</span></div>
          <div class="detail-item"><span class="detail-label">Period</span><span class="detail-value">{{ report.academicPeriod || '—' }}</span></div>
          <div class="detail-item"><span class="detail-label">Institution</span><span class="detail-value">{{ report.institutionName || '—' }}</span></div>
          <div class="detail-item"><span class="detail-label">Average</span><span class="detail-value">{{ report.averageScore !== null && report.averageScore !== undefined ? (report.averageScore | number: '1.2-2') : '—' }}</span></div>
        </div>

        @if (report.summary) {
          <p class="detail-note">{{ report.summary }}</p>
        }

        @if (report.documentObjectKey) {
          <button type="button" class="btn btn-secondary btn-sm" (click)="download(report)">
            <i class="fas fa-download"></i> Download academic record
          </button>
        } @else {
          <p class="detail-note">No academic record was attached.</p>
        }

        @if (canReview(report) && authorization.hasPermission(permissions.AwardManage)) {
          <h3 class="section-heading">Review</h3>
          <form [formGroup]="reviewForm" class="form-grid">
            <label>
              Decision
              <select formControlName="decision">
                <option value="Approve">Approve</option>
                <option value="Resubmit">Send back for resubmission</option>
                <option value="Reject">Reject</option>
              </select>
            </label>
            <label>
              Feedback for the student
              <textarea rows="3" formControlName="feedback"></textarea>
            </label>
          </form>
        }
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
        @if (canReview(report) && authorization.hasPermission(permissions.AwardManage)) {
          <button type="button" class="btn btn-primary" (click)="review()" [disabled]="busy()">
            {{ busy() ? 'Saving…' : 'Submit review' }}
          </button>
        }
      </div>
    </div>
  </div>
}
